import request from 'utils/request'

// 获取表格数据
export const getTableData = data => request().post('score/page', data)

// 下载
export const download = id =>
  request().get(`score/export/${id}`, { responseType: 'blob' })

// 人工调整
export const manualUpdate = data => request().post('score/manual', data)

// 查询评分卡详情
export const queryScore = id => request().get(`score/query/${id}`)
export const queryScoreCard = id => request().get(`score/queryScoreCard/${id}`)

// 导出评分卡
export const exportScoreCard = id =>
  request().get(`score/export/${id}`, { responseType: 'blob' })

// 新增评分卡
export const queryCalculateData = data =>
  request().post('score/queryCalculateData', data)

// 评分
export const calculate = data => request().post('score/calculate', data)

// 自定义评分卡评分
export const calculateCard = data => request().post('score/calculateCard', data)

// 获取评分卡LIST[] ,包含“冻结”状态的
export const getAllRating = () => request().post('card/selectAllRating/list')

// 获取评分卡LIST[] ,不包含“冻结”状态的
export const getRating = () => request().post('card/selectRating/list')
